<template>
  <div>
    <div class="topLayout">
      <yd-navbar-back-icon @click.native = "backMonthAction()"></yd-navbar-back-icon>
      <div v-if="markDate" class="titleLayout">
        {{getMonth()}}
      </div>
      <yd-navbar-next-icon @click.native = "nextMonthAction()"></yd-navbar-next-icon>
    </div>
    <div class="columnLayout">
      <div class="weekLayout" v-for="(week, idx) in columns" :key="idx">
        {{week}}
      </div>
    </div>
    <div class="contentLayout" v-if="itemArray && itemArray.length>0">
      <div class="contentItemLayout" v-for="(item, index) in itemArray" :key="index">
          <div v-if="item.weekDay > 0" class="showDayLayout" @click="tapDayAction(item)">
            <p :class="{'todayTextLayout':(isToday(item.date) && !item.selected),
                        'todayTextSelectedLayout':(isToday(item.date) && item.selected),
                        'dayTextLayout':(!isToday(item.date) && !item.selected),
                        'dayTextSelectedLayout':(!isToday(item.date) && item.selected)}">
              {{getDayByDate(item.date)}}</p>
            <div v-if="item.adultSupplyPrice" :class="{'triangleLayout':!item.selected, 'triangleSelectedLayout':item.selected}"><p></p></div>
            <div :class="{'priceNormalLayout':!item.selected, 'priceSelectedLayout':item.selected,'disabled':dateNow>=item.date}" v-if="item.adultSupplyPrice">
              <p v-if="item.adultSupplyPrice">成人<span>¥{{saleIid?item.adultNormalPrice:item.adultSupplyPrice}}</span></p>
              <p v-if="item.childSupplyPrice">儿童<span>¥{{saleIid?item.childNormalPrice:item.childSupplyPrice}}</span></p>
              <p v-if="item.num">剩余{{item.num}}</p>
            </div>
          </div>
          <div v-else></div>
      </div>
    </div>
  </div>
</template>

<script>
import appService from '@/services/request/appService'
export default {
  name: 'EventCalendar',
  props:['actId', 'clickDate'],
  data() {
    return {
      itemArray: [],
      dateNow:'',
      markDate: '',
      columns: ['日','一','二','三','四','五','六'],
      saleIid:this.$route.query.saleIid?this.$route.query.saleIid:''
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.initData()
    })
  },
  methods: {
    initData() {
      this.markDate = new Date()
      this.getActivityInfoByMonth(() => {
        if(this.clickDate) {
          var tempItemArray = []
          for(var i = 0; i < this.itemArray.length; i++) {
            var item = this.itemArray[i]
            item.selected = this.isSameDay(this.clickDate, item.date)
            tempItemArray.push(item)
            if(new Date().getTime()<item.date) {
              console.log(true)
            }   
            console.log(item.date)   
          }
          this.itemArray = tempItemArray
        }
        this.dateNow = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)

        console.log(this.dateNow)

        console.log('itemArray',this.itemArray)
      })      
    },
    getMonth() {
      var date = this.markDate
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      if (month >= 1 && month <= 9) {
        month = "0" + month
      }
      return year + '年' + month + '月'
    },
    getBeforeDate(offDay) {
      var newDate = new Date();
      newDate.setDate(newDate.getDate()-offDay)
      return newDate.getTime()
    },
    getDayByDate(timeStamp) {
      var date = new Date(timeStamp) 
      return date.getDate()
    },
    changeDateToTimeStamp(dateStr) {
      var date = new Date(dateStr)
      var timeStamp = date.getTime()
      return timeStamp
    },
    isToday(timeStamp){
      var today = new Date()
      var date = new Date(timeStamp)
      if(date.getFullYear() !== today.getFullYear())  return false
      if(date.getMonth() !== today.getMonth())  return false
      if(date.getDate() !== today.getDate())  return false
      return true
    },
    isSameDay(timeStamp1, timeStamp2){
      var date1 = new Date(timeStamp1)
      var date2 = new Date(timeStamp2)
      if(date1.getFullYear() !== date2.getFullYear())  return false
      if(date1.getMonth() !== date2.getMonth())  return false
      if(date1.getDate() !== date2.getDate())  return false
      return true
    },
    getActivityInfoByMonth(callback) {
      var timeStamp = this.markDate.getTime()
      appService
          .getActivityCalendar({
              detailId: this.actId,
              time: timeStamp,
          })
          .then(data => {
            this.itemArray = data
            var firstDay = this.itemArray[0]
            var insertDayNum = firstDay.weekDay == 7 ? 0 : firstDay.weekDay
            for(var i = 1; i <= insertDayNum; i++) {
              var tempDate = this.getBeforeDate(i)
              var addItem = {"date": tempDate}
              this.itemArray.splice(0, 0, addItem)
            }
            if(typeof callback === 'function') callback()
          }, error => {
              if(error && error.sub_msg) {
                  this.$dialog.toast({
                      msg: error.sub_msg,
                      timeout: 1500,
                  })
              }else if(error && error.msg) {
                  this.$dialog.toast({
                      msg: error.msg,
                      timeout: 1500,
                  })
              }
          })
    },
    backMonthAction() {
      var year = this.markDate.getFullYear()
      var month = this.markDate.getMonth()
      if(month < 1) {
        year -= 1
        month = 12
      }else if(month >= 1 && month <= 9) {
        month = '0' + month
      }  
      var day = this.markDate.getDate()
      if(day >= 1 && day <= 9)  day = '0' + day
      var dateFormat = year + '-' + month + '-' + day
      this.markDate = new Date(dateFormat)
      this.getActivityInfoByMonth()
    },
    nextMonthAction() {
      var year = this.markDate.getFullYear()
      var month = this.markDate.getMonth() + 2
      if(month > 12) {
        year += 1
        month = '01'
      }else if(month >= 1 && month <= 9) {
        month = '0' + month
      }
      var day = this.markDate.getDate()
      if(day >= 1 && day <= 9)  day = '0' + day
      var dateFormat = year + '-' + month + '-' + day
      this.markDate = new Date(dateFormat)
      this.getActivityInfoByMonth()
    },
    tapDayAction(tapItem) {
      if(!tapItem.adultSupplyPrice) return
      if(this.dateNow>=tapItem.date)return
      var tempItemArray = []
      for(var i = 0; i < this.itemArray.length; i++) {
        var item = this.itemArray[i]
        item.selected = item.date == tapItem.date? true : false   
        tempItemArray.push(item)       
      }
      this.itemArray = tempItemArray
      setTimeout(() => {
        this.$emit('getDateInfoFromCalendar', tapItem)  
      }, 200);
      
    }
  }
}
</script>

<style scoped lang="less">
.topLayout{
  display: flex;
  height: 1.0rem;
  line-height: 1.0rem;
  font-size: 0.32rem;
  text-align: center;
  align-content: center;
  justify-content: center;
  background-color: white;
}
.topLayout .titleLayout{
  text-align: center;
  margin: auto 30px;
}
.columnLayout{
  display: flex;
  width: 100%;  
  flex-wrap: wrap;
  background-color:#fff;
  padding: 0px 12px 6px 12px;
}
.columnLayout .weekLayout{
  width: calc((100% - 28px)/7);
  height: 0.60rem;
  line-height: 0.60rem;
  margin: auto;
  padding: auto;
  text-align: center;
  font-size: 0.28rem;
  font-weight: bold;
  color: #333;
}
.contentLayout{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  background-color:#fff;
  padding: 4px 12px;
}
.contentLayout .contentItemLayout{
  width: calc((100% - 28px)/7);
  // height: 1.30rem;
  margin: 1px 2px;
  text-align: center;
  text-align: center;
  justify-content: center;
  color: #333;
  
}
.contentLayout .contentItemLayout .priceNormalLayout p{
  font-size: 0.14rem!important;
}
.priceSelectedLayout p{
  font-size: 0.14rem!important;
}
.contentLayout .contentItemLayout .showDayLayout{
  color: #666;
  font-size:0.18rem;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.contentLayout .contentItemLayout .showDayLayout .todayTextLayout{
  font-size: 0.24rem;
  width: 0.50rem;
  height: 0.50rem;
  line-height: 0.50rem;
  text-align: center;
  margin: auto;
  margin-top: -1px;
  font-weight: bold;
  border: solid 1px #64b572;
  border-radius: 50%;
}
.contentLayout .contentItemLayout .showDayLayout .todayTextSelectedLayout{
  font-size: 0.24rem;
  width: 0.50rem;
  height: 0.50rem;
  line-height: 0.50rem;
  text-align: center;
  margin: auto;
  margin-top: -1px;
  font-weight: bold;
  border: solid 1px #64b572;
  border-radius: 50%;
  color: #64b572;
}
.contentLayout .contentItemLayout .showDayLayout .dayTextLayout{
  font-size: 0.24rem;
  width: 0.50rem;
  height: 0.50rem;
  line-height: 0.50rem;
  text-align: center;
  margin: auto;
  font-weight: bold;
  color: #333;
}
.contentLayout .contentItemLayout .showDayLayout .dayTextSelectedLayout{
  font-size: 0.24rem;
  width: 0.50rem;
  height: 0.50rem;
  line-height: 0.50rem;
  text-align: center;
  margin: auto;
  font-weight: bold;
  color: #64b572;
}
.contentLayout .contentItemLayout .showDayLayout .triangleLayout{
  height: 0;
  margin-top: -0.36rem;
}
.contentLayout .contentItemLayout .showDayLayout .triangleLayout :before{
  content:"";
  border-width:4px 4px 4px 4px;
  border-style:solid;
  border-color:transparent transparent rgba(102,102,102,0.8) transparent;
  width: 0;
  height: 0;
}
.contentLayout .contentItemLayout .showDayLayout .triangleSelectedLayout{
  height: 0;
  margin-top: -0.36rem;
}
.contentLayout .contentItemLayout .showDayLayout .triangleSelectedLayout :before{
  content:"";
  border-width:4px 4px 4px 4px;
  border-style:solid;
  border-color:transparent transparent rgba(0,128,0,0.8) transparent;
  width: 0;
  height: 0;
}
.contentLayout .contentItemLayout .showDayLayout .priceNormalLayout{
  margin-top: 0.34rem;
  font-size:0.16rem;
  text-align: center;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  border-color: rgba(102,102,102,0.8);  
  &.disabled{
    background: #eee;
  }
}
.contentLayout .contentItemLayout .showDayLayout .priceSelectedLayout{
  margin-top: 0.34rem;
  font-size:0.16rem;
  text-align: center;
  border-radius: 4px;
  background-color: rgba(0,128,0,0.8);
  border:none;   
  color: white;
}
.contentLayout .contentItemLayout .showDayLayout .priceNormalLayout span{
  color:crimson; 
}
.contentLayout .contentItemLayout .showDayLayout .priceSelectedLayout span{
  color:white; 
}
</style>
